/** Platform admin: dashboard screen (P9, mockups/admin/dashboard.html). fil mirrors every key. */
export const dashboard = {
  title: "Platform overview",
  subtitle: "All tenants, revenue and AI spend across Sagot · as of {{when}} PHT",
  periods: { label: "Reporting period", mtd: "This month", qtd: "Quarter", ytd: "Year" },
  exportReport: "Export report",
  exportUnavailable: "Board report export isn't available yet",
  createTenant: "Create tenant",
  status: {
    title: "System status",
    allUp: "All operational",
    degraded: "Degraded: {{count}}",
    down: "Down: {{count}}",
    unknown: "Unknown: {{count}}",
    open: "Open System Health",
    states: { up: "Operational", degraded: "Degraded", down: "Down", unknown: "Unknown" },
  },
  kpi: {
    mrrUsd: "≈ {{usd}} at the stored FX rate",
    mrr: "MRR",
    mrrDelta: "{{delta}} vs {{month}}",
    mrrFlat: "No change vs {{month}}",
    active: "Active tenants",
    activeDelta: "+{{count}} this month",
    activeFoot: "{{count}} suspended",
    paying: "Paying",
    payingFoot: "ARPA {{arpa}} · {{pastDue}} past due",
    trial: "On trial",
    trialFoot_one: "{{count}} expires in the next 7 days",
    trialFoot_other: "{{count}} expire in the next 7 days",
    churn: "Logo churn (30d)",
    churnFoot_one: "{{count}} cancellation",
    churnFoot_other: "{{count}} cancellations",
    messages: "Messages this month",
    messagesPeriod: "Messages ({{period}})",
    messagesFoot: "user + AI · {{conversations}} conversations",
    aiCost: "AI cost ({{period}})",
    aiCostFoot: "≈ {{php}}",
    aiCostBudget: "≈ {{php}} · {{pct}} of {{budget}} budget",
    margin: "Gross margin",
    marginFoot: "Revenue {{revenue}} this period",
  },
  mrr: {
    title: "MRR trend",
    subtitle: "{{from}} – {{to}} · recurring subscriptions + add-ons, net of discounts",
    growth: "{{multiple}}× in 12 months",
    chart: "Monthly recurring revenue, last 12 months",
    series: "MRR",
    change: "Change vs last month",
    best: "Best month",
    average: "12-month average",
    months: "Months with revenue",
  },
  signups: {
    title: "Signups vs conversions",
    subtitle: "Trials started vs converted to paid",
    signups: "Signups",
    converted: "Converted",
    chart: "Signups and conversions per month",
    rate: "Trial → paid (6 mo)",
    total: "Signups (6 mo)",
    bar: "{{month}}: {{signups}} signups, {{converted}} converted",
  },
  industry: {
    title: "Tenants by industry",
    subtitle_one: "{{count}} active tenant",
    subtitle_other: "{{count}} active tenants",
    browse: "Browse tenants",
    item: "{{count}} tenants · {{mrr}} MRR",
    itemNoMrr: "{{count}} tenants",
    segment: "{{label}} — {{count}} tenants ({{pct}})",
    largest: "Largest segment",
    highestMrr: "Highest MRR",
    industries: "Industries",
  },
  plans: {
    title: "Plan mix",
    manage: "Manage plans",
    row: "{{count}} · {{mrr}}",
    rowNoMrr: "{{count}} tenants",
    custom: "custom",
  },
  recent: {
    title: "Recent signups",
    all: "All tenants",
    colTenant: "Tenant",
    colIndustry: "Industry",
    colPlan: "Plan",
    colOwner: "Owner",
    colSignedUp: "Signed up",
    emptyTitle: "No tenants yet",
    emptyBody: "New workspaces appear here as soon as they sign up.",
  },
  alerts: {
    title: "Alerts",
    open_one: "{{count}} open",
    open_other: "{{count}} open",
    emptyTitle: "No open alerts",
    emptyBody: "Usage limits, failed payments, abuse reports and queue spikes show up here.",
    viewTenant: "View tenant",
    reviewCase: "Review case",
    seeCosts: "See costs",
    openSystem: "Open System Health",
    dismiss: "Dismiss",
    dismissed: "Alert dismissed",
  },
} as const;
